var icon_button_default = {
  "audioIconButton": "OBC1s"
};
export {
  icon_button_default as default
};
//# sourceMappingURL=icon-button-scss.js.map
